import { styled } from 'styled-components';

export const AppContainer = styled.div`
  background-color: ${({ theme }) => theme.menu.palette.black};
  padding: ${({ theme }) => theme.menu.spacing(4)};
  max-width: 1000px;
  margin: 0 auto;
  background: 0 0 url('/img/header-bg.jpg') no-repeat;
`;
